import { render, staticRenderFns } from "./games-info-overlay.vue?vue&type=template&id=d2685bc0&"
import script from "./games-info-overlay.vue?vue&type=script&lang=js&"
export * from "./games-info-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports